import { render, staticRenderFns } from "./seller_chat.vue?vue&type=template&id=0634bd84&scoped=true"
import script from "./seller_chat.vue?vue&type=script&lang=js"
export * from "./seller_chat.vue?vue&type=script&lang=js"
import style0 from "./seller_chat.vue?vue&type=style&index=0&id=0634bd84&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0634bd84",
  null
  
)

export default component.exports